import React, { useState, useEffect } from "react";
import { Modal } from "../../Modal";
import * as S from "./styles";
import { useTranslation } from "react-i18next";

function secondsToTime(seconds) {
  // Hours, minutes and seconds
  var hrs = ~~(seconds / 3600);
  var mins = ~~((seconds % 3600) / 60);
  var secs = ~~seconds % 60;

  // Output like "1:01" or "4:03:59" or "123:03:59"
  var ret = "";
  if (hrs > 0) {
    ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
  }
  ret += "" + mins + ":" + (secs < 10 ? "0" : "");
  ret += "" + secs;
  return ret;
}

export function ModalRecordAudio({
  showModal,
  handleCancel,
  handleConfirm,
  mediaRecorder,
}) {
  const [seconds, setSeconds] = useState(0);
  const { t } = useTranslation();

  useEffect(() => {
    if (mediaRecorder?.state == "recording") {
      const timeout = setTimeout(
        () => (Boolean(seconds) || seconds == 0) && setSeconds(seconds + 1),
        1000
      );

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [seconds]);

  return (
    <Modal
      open={showModal}
      size="medium"
      disableBackdropClick
      onClose={handleCancel}
    >
      <S.Container>
        <S.Title>{t("Chat:audio_attachment.recording")}</S.Title>
        <S.Timer>{secondsToTime(seconds)}</S.Timer>

        <S.Actions>
          <S.CancelAction>
            <S.BorderedButton color="#ED5565" onClick={handleCancel}>
              <S.CloseIcon />
            </S.BorderedButton>

            <S.ActionTitle color="#ED5565">
              {t("Chat:audio_attachment.discard")}
            </S.ActionTitle>
          </S.CancelAction>

          <S.FinishAction>
            <S.BorderedButton color="#63afef" onClick={handleConfirm}>
              <S.StopIcon />
            </S.BorderedButton>

            <S.ActionTitle color="#63afef">
              {t("Chat:audio_attachment.finish")}
            </S.ActionTitle>
          </S.FinishAction>
        </S.Actions>
      </S.Container>
    </Modal>
  );
}
